﻿import React, {HTMLInputAutoCompleteAttribute, JSX} from "react";
import {HtmlRequiredPrefixedControlProps} from "./HtmlControlProps";
import LabeledControl from "./LabeledControl";
import {useLabeledControl} from "./LabeledControlData";

export interface TextAreaProps extends HtmlRequiredPrefixedControlProps<HTMLTextAreaElement> {
	maxLength?: number;
	minLength?: number;
	placeholder?: string;

	rows?: number;
	cols?: number;
	wrap?: "hard" | "soft" | "off" | undefined;
	spellCheck?: boolean;

	autoComplete?: HTMLInputAutoCompleteAttribute;
	autoCapitalize?: "off" | "none" | "on" | "sentences" | "words" | "characters" | undefined | string & {};
	autoFocus?: boolean;
}

export default function TextArea(props: TextAreaProps): JSX.Element {
	const {
		label,
		name,
		value,
		id,
		column,
		disabled,
		hidden,
		onChange,
		onBlur,
		onClick,
		ref,

		required,
		hint,
		error,
		inlineError,

		controlPrefix,
		controlSuffix,

		maxLength,
		minLength,
		placeholder,
		rows,
		cols,
		wrap,
		spellCheck,
		autoComplete,
		autoCapitalize,
		autoFocus
	} = props;

	const {componentId, ariaRef} = useLabeledControl(id, hint, error);
	if (hidden) {
		return <></>;
	}

	return <LabeledControl label={label} type="text-area" id={componentId} required={required} column={column} disabled={disabled} clickable={disabled && onClick != null}
	                       error={error} inlineError={inlineError}
	                       hint={hint} hidden={hidden} ariaRef={ariaRef} controlPrefix={controlPrefix}
	                       controlSuffix={controlSuffix}>
		<textarea
			id={componentId}
			ref={ref}
			onChange={onChange}
			onBlur={onBlur}
			onClick={onClick}
			name={name}
			value={onChange == null ? undefined : value}
			defaultValue={onChange == null ? value : undefined}
			required={required}
			maxLength={maxLength}
			minLength={minLength}
			placeholder={placeholder}
			autoComplete={autoComplete}
			autoFocus={autoFocus}
			rows={rows}
			cols={cols}
			wrap={wrap}
			spellCheck={spellCheck}
			autoCapitalize={autoCapitalize}
			readOnly={disabled}
			aria-describedby={ariaRef.current?.describedBy}
			aria-invalid={ariaRef.current?.invalid}
			aria-required={required}
			tabIndex={disabled ? -1 : undefined}
		/>
	</LabeledControl>;
};
